import React from 'react';
import { Container, Label, SVGImageIcon, ToggleBox } from './order-selector.styled';
import { OrderOptions } from './order-selector.types';
export const OrderSelector = ({ orderBy = OrderOptions.POPULARITY, label, sortAction, }) => {
    const orderByPopularity = orderBy === OrderOptions.POPULARITY;
    const starIcon = `https://statics.addi.com/ui-storybook/star${orderByPopularity ? '-selected' : ''}.svg`;
    const aTozIcon = `https://statics.addi.com/ui-storybook/a-to-z${!orderByPopularity ? '-selected' : ''}.svg`;
    return (React.createElement(Container, null,
        React.createElement(Label, null, label),
        React.createElement(ToggleBox, { onClick: sortAction },
            React.createElement(SVGImageIcon, { selected: orderByPopularity, src: starIcon }),
            React.createElement(SVGImageIcon, { selected: !orderByPopularity, src: aTozIcon }))));
};
//# sourceMappingURL=OrderSelector.js.map